import { useQuery } from "@tanstack/react-query";
import { getAppConfig } from "services/apis/config";
import { cacheAppConfig } from "services/utils/appConfig";

export const useAppConfig = () => {
  return useQuery({
    queryKey: ["appConfig"],
    queryFn: async () => {
      const config = await getAppConfig();
      cacheAppConfig(config);
      return config;
    },
    staleTime: 60 * 1000,
    refetchOnMount: "always",
  });
};
